<script>
  import Breadcrumbs from "../../../parts/Breadcrumbs.svelte";
  import { getAutoMpsProjectContext } from "../../../AutoMpsProjectContext.js";

  export let viewName

  const ctx = getAutoMpsProjectContext()

  $: breadcrumbItems = [
    {
      title: "実行一覧",
      href: `/auto-mps/projects/${$ctx.projectId}/executions`
    },
    {
      title: $ctx.executionId,
      href: `/auto-mps/projects/${$ctx.projectId}/executions/${$ctx.executionId}`
    },
    {
      title: viewName,
      active: true,
    }
  ]
</script>

<div class="view-root">
  <Breadcrumbs
    items={breadcrumbItems}
  />
  <slot />
</div>

<style>
  .view-root {
    padding: 1rem;
    height: 100%;
    background-color: #f5f5f5;
  }
</style>
